import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { showHideFolderPermissionDialog } from '../actions/internalActions';

// Mutate folder Id according to the value in actionMessage
export const mutateFolderIdOnShouldShowFolderPermissionsDialog = mutator(
    showHideFolderPermissionDialog,
    actionMessage => {
        getStore().folderId = actionMessage.folderId;
    }
);
